import React from 'react';
import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import styles from './styles/user-detail-row.module.scss';

/**
 * Key/value row used inside `UserDetailSection` for the USER DETAILS and
 * ACCOUNT SERVICING blocks of the user detail panel. Falls back to "—"
 * when `value` is empty so the row never renders a blank right side.
 *
 * @param {Object} props
 * @param {string} props.label
 * @param {React.ReactNode | string | number | null | undefined} props.value
 */
function UserDetailRow({ label, value }) {
    return (
        <div className={styles.detailRow}>
            <Text as={TextAs.SPAN} size={TextSizes.SMALL} className={styles.detailLabel}>
                {label}
            </Text>
            <Text as={TextAs.SPAN} size={TextSizes.SMALL} className={styles.detailValue}>
                {value || '—'}
            </Text>
        </div>
    );
}

export default UserDetailRow;
